import { render, staticRenderFns } from "./PedidoDropdownItem.vue?vue&type=template&id=3b4a1bc7&scoped=true"
import script from "./PedidoDropdownItem.vue?vue&type=script&lang=js"
export * from "./PedidoDropdownItem.vue?vue&type=script&lang=js"
import style0 from "./PedidoDropdownItem.vue?vue&type=style&index=0&id=3b4a1bc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4a1bc7",
  null
  
)

export default component.exports